import React from 'react';

import { env } from '@/common/config';

import LostPageIlustration from '@/shared/assets/vetco/noBids.png';

import {
  ErrorScreen,
  ErrorScreenTitle,
  ErrorScreenMessage,
  ErrorScreenButton,
  ErrorScreenIlustration,
  Exception,
  Pre,
} from './ErrorScreen.styled';
import { Button, Text, Title } from '../../elements';

const reload = (event) => {
  event.preventDefault();
  window.location.reload(true);
};

export default ({
  error,
  retry = reload,
  showStackTrace = false,
  retryText = 'Reload page',
  title = 'Something went wrong :(',
  feedback = 'Let us take a look into it!',
  message = 'Sorry, we seem to be having trouble loading this page\'s content',
}) => (
  <ErrorScreen>
    <ErrorScreenIlustration>
      <img src={LostPageIlustration} alt="error screen ilustration" />
    </ErrorScreenIlustration>
    <ErrorScreenTitle>
      <Title as="h2">{title}</Title>
    </ErrorScreenTitle>
    <ErrorScreenMessage>
      <Text>{message}</Text>
      <Text>{feedback}</Text>
    </ErrorScreenMessage>
    <ErrorScreenButton>
      <Button primary onClick={retry} label={retryText} />
    </ErrorScreenButton>
    {env === 'dev' && showStackTrace && (
      <Exception>
        <Pre>
          <code>
            <div>
              # It seems you&apos;re a developer, so here&apos;s the error stack
              trace
            </div>
            {error.stack}
          </code>
        </Pre>
      </Exception>
    )}
  </ErrorScreen>
);
